export default "__VITE_ASSET__DtvAJnwN__"